
import { defineComponent } from 'vue'
import { formatDate, parseISODate } from '~/utils/date'
export default defineComponent({
  name: 'BillingAlertScheduledCancel',
  props: {
    planName: {
      type: Object,
      required: true
    },
    cancellationDate: {
      type: String,
      required: true
    }
  },
  methods: {
    formatDate,
    parseISODate
  }
})
